import { ReactComponent as EyeIcon } from 'assets/images/icon/eye-icon.svg';
import { FC } from 'react';
import cls from './input-passwod-hide-and-show.module.scss';


type IProps = {
    onClick: () => void,
    className?: string
};

const InputPasswodHideAndShow: FC<IProps> = ({
    onClick,
    className,
    children,
    ...props
}) => {
    return (
        <div className={`${cls.inputPasswordWrapper} ${className}`} {...props}>
            {children}
            <div
                className={cls.showPasswordStyle}
                onClick={onClick}
            >
                <EyeIcon />
            </div>
        </div>
    );
};

export default InputPasswodHideAndShow;
